module.exports = __webpack_public_path__ + "img/USD.a1c10dbd.svg";